import { FormHelper } from 'projects/admin/src/app/shared/form-helper';
import { Router } from '@angular/router';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { UntypedFormBuilder, UntypedFormControl, Validators, FormGroup } from '@angular/forms';
import { BaseForm } from 'projects/admin/src/app/classes/base-form';
import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { CustomerModel } from 'projects/core/src/lib/models/customer.model';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';
import { CountryModel } from 'projects/core/src/lib/models/country.model';
import { HelperService } from 'projects/admin/src/app/services/helper.service';
import { CustomValidators } from 'projects/core/src/lib/validators/custom.validators';
import { parsePhoneNumber } from 'libphonenumber-js';

@Component({
  selector: 'app-customer-new',
  templateUrl: './customer-new.component.html',
  styleUrls: ['./customer-new.component.scss']
})
export class CustomerNewComponent extends BaseForm implements OnInit {

  public countries: Array<CountryModel> = [];

  public form = this.fb.group({
    number: new UntypedFormControl(''),
    name: new UntypedFormControl('', [Validators.required]),
    company: new UntypedFormControl(''),
    street: new UntypedFormControl(''),
    zip: new UntypedFormControl(''),
    city: new UntypedFormControl(''),
    country: new UntypedFormControl(''),
    phone: new UntypedFormControl('', [CustomValidators.phone()]),
    email: new UntypedFormControl('', [CustomValidators.email()]),
    web: new UntypedFormControl('', [CustomValidators.url()]),
    informations: new UntypedFormControl(''),
  });

  constructor(
    private fb: UntypedFormBuilder,
    private ui: UiService,
    private api: ApiService,
    private router: Router,
    private auth: AuthStateService,
    private transloco: TranslocoService,
    private helper: HelperService
  ) {
    super();
  }

  ngOnInit() {
    if (this.auth.checkRightOrRedirect('admin.customer.create')) {
      this.loading = true;
      this.api.getModels('countries').subscribe({
        next: (result: any) => {
          this.countries = this.helper.getCountryOptions(result.data);
        }
      }).add(() => {
        this.loading = false;
      });
      this.ui.setFormFocus();
    }
  }

  onCancel(): void {
    this.router.navigate(['/customers']);
  }

  onSubmit(): void {
    this.ui.hideMessage();
    if (this.form.valid === true) {
      this.submitting = true;
      const payload = this.form.value;
      payload.country = payload.country?.country_code || null;
      const phone = (this.form.value.phone) ? parsePhoneNumber(this.form.value.phone, payload.country || 'DE') : null;
      payload.phone = phone?.formatInternational() || null;
      this.api.saveModel('customers', null, payload).subscribe({
        next: (result: any) => {
          const customer = new CustomerModel().deserialize(result.data);
          this.ui.toastSuccess(this.transloco.translate('common.messages.saved', { value: customer.name }), this.transloco.translate('common.saved'));
          this.router.navigate(['/customers', customer.id]);
        },
        error: (error: any) => {
          this.ui.showMessage('error', this.transloco.translate(error.message), this.transloco.translate('common.error'));
          FormHelper.setBackendErrors(this.form, error.fielderrors);
        }
      }).add(() => {
        this.submitting = false;
      });
    } else {
      this.ui.showMessage('error', this.transloco.translate('common.error_on_form_please_correct'), this.transloco.translate('common.error'));
      FormHelper.markFormAsDirty(this.form);
    }
  }

}
